import { mapGetters } from 'vuex';
import contentHeader from '@/components/generics/content-header/content-header.vue';
import research from '@/components/research/research.vue';
import videos from '@/components/support/videos/videos.vue';
import twitterTimeline from '@/components/twitter/twitter-timeline/twitter-timeline.vue';

export default {
  components: {
    contentHeader,
    research,
    twitterTimeline,
    videos,
  },
  metaInfo() {
    return {
      title: 'Research',
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-research/page-research.js